/** Original source code: https://github.com/Modernizr/Modernizr/blob/v3.11.4/src/omPrefixes.js **/
var omPrefixes = 'Moz O ms Webkit';
export default omPrefixes;
